angular.module('study-environment').component('sharecrfEnvironment', {
    templateUrl: 'modules/study-environment/template.html',
    controller: ['StudyEnvironment', function(StudyEnvironment) {
        var vm = this;

        vm.show = StudyEnvironment.isTest();
    }],
});
